<template>
  <div>
    <div class="majorTitle">
      Update Your Email
    </div>
    <div class="row update-container">
      <form @submit="updateAccount">
        <label>Current Email</label>
        <input
          id="email"
          v-model="customer.email"
          type="email"
          name="email"
          disabled
        >

        <label>New Email</label>
        <input
          id="newEmail"
          v-model="newEmail"
          type="email"
          name="newEmail"
          required
        >

        <div class="bottom-buttons">
          <button
            id="exitButton"
            type="button"
            class="button"
            @click="exit()"
          >
            Exit
          </button>
          <button
            id="submitButton"
            type="submit"
            class="button"
          >
            Save
          </button>
        </div>
      </form>
    </div>

    <LoadingOverlayComponent
      v-if="showLoading"
      :title="loadingTitle"
    />

    <AlertComponent
      v-if="showRegulatAlert"
      :title="regularAlertTitle"
      :message="regularAlertMessage"
      :secondary-action="null"
      @close="closeAlert()"
    />
  </div>
</template>

<script>
import LoadingOverlayComponent from '@/components/Shared/LoadingOverlayComponent.vue'
import AlertComponent from '@/components/Shared/AlertComponent.vue'
import apiMixin from '@/mixins/apiMixin.js'

export default {
	name: 'UpdateEmailComponent',
	components: {
		LoadingOverlayComponent,
		AlertComponent
	},
	mixins: [apiMixin],

	props: [
		'token',
		'customerId'
	],
	data () {
		return {
			loadingTitle: 'Gathering your account details',
			loadingSubTitle: '',
			showLoading: true,

			showRegulatAlert: false,
			regularAlertTitle: '',
			regularAlertMessage: '',

			newEmail: '',
			shouldCloseModalAndNotExit: false
		}
	},

	computed: {
		customer: function () {
			return this.$store.getters.customer
		}
	},
	watch: {
		customer: function (customer) {
			if (customer.customer_id) {
				this.showLoading = false
			} else {
				this.showLoading = true
			}
		}
	},

	mounted () {
		// If no token was passed in, get out
		if (this.token === undefined) {
			this.exit()
		}
	},

	methods: {
		updateAccount (e) {
			e.preventDefault()

			var cmp = this
			let apiPayload = {}
			apiPayload.apiEndpoint = 'account'
			apiPayload.postData = {}
			apiPayload.postData.action = 'update_customer_email'
			apiPayload.postData.email = this.newEmail
			apiPayload.postData.customer_id = this.customer.customer_id

			this.loadingTitle = 'Updating your account'
			this.showLoading = true
			cmp.$store.dispatch('apiCall', apiPayload).then(response => {
				this.showLoading = false
				if (response.data.result !== 'success') {
					this.regularAlertTitle = 'Error'
					this.regularAlertMessage = response.data.message
					this.shouldCloseModalAndNotExit = true // when the alert is closed, don't exit the page
					this.showRegulatAlert = true
				} else {
					this.regularAlertTitle = 'Account Updated'
					this.regularAlertMessage = 'Your account has been updated.'
					this.shouldCloseModalAndNotExit = false // when the alert is closed, exit the page
					this.showRegulatAlert = true
				}
			})
		},
		closeAlert () {
			this.showRegulatAlert = false
			if (!this.shouldCloseModalAndNotExit) {
				this.exit()
			}
		},
		exit () {
			const referrer = localStorage.getItem('exit-referrer')
			if (referrer) {
				// If we have a exit-referrer, redirect to it
				window.location.replace(referrer)
				return
			}
			// Otherwise, redirect to the home page
			window.location.replace(this.getUrlHost(this.$store.getters.apiPath))
		}
	}
}
</script>

<style scoped>
.update-container {
	margin: auto;
	display: flex;
	flex-direction: column;
	align-items: center;
	max-width: 450px;
}

.bottom-buttons {
	margin-top: 16px;
}

#submitButton {
	background-color: #007AFF;
	color: white;
	border: 1px solid #007AFF;
	border-radius: 8px;
}

#exitButton {
	background-color: #ffffff;
	color: #333333;
	border-radius: 8px;
	margin: 0;
	margin-right: 40px;
	border: 1px solid rgba(51, 51, 51, 0.7);
}
</style>
